import { SpyneTrait } from 'spyne';

const EARLY_ACCESS_ENDPOINT = 'https://h8joc5mbya.execute-api.us-east-1.amazonaws.com/prod/early-access';

export class EarlyAccessTraits extends SpyneTrait {

  constructor(context) {
    let traitPrefix = "earlyAccess$";
    super(context, traitPrefix);
  }

  static earlyAccess$OnFormSubmit(evt) {

    const form$       = this.props.el$('#early-access-form');
    const success$    = this.props.el$('#early-access-success');
    const email$      = this.props.el$('#ea-email');
    const context$    = this.props.el$('#ea-context');
    const honeypot$   = this.props.el$('#ea-website');
    const submit$     = this.props.el$('#ea-submit');
    const submitLbl$  = this.props.el$('.early-access-form__submit-label');
    const error$      = this.props.el$('#ea-email-error');

    const email    = email$.el.value.trim();
    const context  = context$.el.value.trim();
    const honeypot = honeypot$.el.value;

    if (!EarlyAccessTraits.isValidEmail(email)) {
      email$.addClass('is-invalid');
      error$.el.textContent = 'Please enter a valid email address.';
      email$.el.focus();
      return;
    }

    submit$.el.disabled = true;
    submit$.addClass('is-loading');
    submitLbl$.el.textContent = 'Requesting…';
    error$.el.textContent = '';

    EarlyAccessTraits.submitEarlyAccess({ email, context, honeypot })
    .then(({ ok, error }) => {
      if (ok) {
        form$.el.hidden = true;
        success$.el.hidden = false;
        success$.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        EarlyAccessTraits.handleServerError({
          error,
          email$,
          error$,
          submit$,
          submitLbl$
        });
      }
    })
    .catch((err) => {
      submit$.el.disabled = false;
      submit$.removeClass('is-loading');
      submitLbl$.el.textContent = 'Request Access';
      error$.el.textContent = 'Something went wrong. Please try again or email frank@spynejs.com directly.';
      console.error('Early access submission failed:', err);
    });
  }

  static handleServerError({ error, email$, error$, submit$, submitLbl$ }) {
    submit$.el.disabled = false;
    submit$.removeClass('is-loading');
    submitLbl$.el.textContent = 'Request Access';

    const messages = {
      invalid_email: 'Please enter a valid email address.',
      role_address_not_allowed: 'Please use a personal email — role addresses (info@, sales@) aren\'t accepted.'
    };

    const userMessage = messages[error] || 'Something went wrong. Please try again or email frank@spynejs.com directly.';

    email$.addClass('is-invalid');
    error$.el.textContent = userMessage;
    email$.el.focus();
  }

  static isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  static async submitEarlyAccess({ email, context, honeypot }) {
    const res = await fetch(EARLY_ACCESS_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        context,
        _website_url: honeypot
      })
    });

    const body = await res.json();
    return { ok: res.ok && body.ok === true, error: body.error };
  }
}
